export const FluxoPagamentoMap = {
  Entrada: 'Entrada',
  Mensais: 'Mensais',
  Intermediarias: 'Intermediárias',
  Saldo: 'Saldo',
  PosConclusao: 'Pós Conclusão',
  Ato: 'Ato',
} as const

export interface IParcelaFluxoPagamento {
  data: string
  tipoDaParcela: keyof typeof FluxoPagamentoMap
  valor: string
}

export interface IFluxoPagamento {
  ano: number
  parcelas: IParcelaFluxoPagamento[]
}
